import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Helper } from '../helpers/Helper';
import { AppTheme } from '../../styles/AppTheme';

const ERROR_MSG = Helper.getString('defaultApiErrMsg')

export class UiHelper {
  static loadingView() {
    return (
      <div  className={css(Styles.container)}>
        <CircularProgress size={48} className={css(Styles.progress)} />
      </div>
    )
  }
  static errorView(caller) {
    return (
      <div className='pageError'>
        {caller.state.errMsg || ERROR_MSG}
      </div>
    )
  }

  static staticErrorView(caller) {
    return (
      <div className={css(Styles.errorContainer)}>
        <div className={css(Styles.imageContainer)}>
          <img src={require('../../assets/images/404.svg')} className={css(Styles.image)} />
        </div>
        <p className={css(Styles.nfMiddle)}>{Helper.getString('serviceErr')}</p>
      </div>
    )
  }

  static componentLoadingView() {
    return (
      <div className={css(Styles.container)}>
        <CircularProgress size={48} className={css(Styles.progress)} />
      </div>
    )
  }

  static emptyView(msg) {
    return (
      <div className={css(Styles.emptyContainer)}>
        <p>{msg}</p>
      </div>
    )
  }

  static componentErrorView(caller) {
    return (
      <div className={css(Styles.container)}>
        <p className={css(Styles.error)}>{caller.state.errMsg || ERROR_MSG}</p>
      </div>
    )
  }
}

const Styles = StyleSheet.create({
  container: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
    height: '100vh',
  },
  containerVarient: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
    height: '60vh',
  },
  emptyContainer: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
    height: '60vh',
    fontWeight: 'bold'
  },
  progress: {
    color: AppTheme.primaryColor
  },
  error: {
    textAlign: 'center',
    maxWidth: 500
  },
  errorContainer: {
    flex: 1,
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: AppTheme.primaryBg,
    flexDirection: 'column'
  },
  imageContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 120,
    height: 120,
    backgroundColor: 'white',
    padding: 20,
    borderRadius: '50%'
  },
  image: {
    maxHeight: '100%',
    maxWidth: '100%'
  },
  nfMiddle: {
    fontSize: 20,
    color: 'white',
    fontWeight: 'bold',
    textAlign: 'center'
  }
})



// WEBPACK FOOTER //
// ./src/common/helpers/UiHelper.js